<template>
  <div class=" mt-6 ">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-row justify="center">
            <v-col cols="6">
              <div class="text-center">
                <v-img :src="require('@/assets/icon/verifikasi_phone.svg')" contain style="width: 366px; height: 340px;" class="mx-auto"></v-img>

                <div class="fs-14 black_three">
                  Kode Verifikasi telah kami kirim melalui SMS atau Whatsapp ke
                </div>

                <div class="fs-18 black_one mt-1 mb-5">
                  {{ `+62 ${$route.params.id}` }}
                </div>

                <div>
                  <div id="divOuter" class="mx-auto">
                    <div id="divInner">
                      <input id="partitioned" type="number" maxlength="6" :value="form.mobile_key" @input="HandleInput($event.target.value)" onKeyPress="if(this.value.length==6) return false;"/>
                    </div>
                  </div>
                </div>

                <div v-if="message.error.length > 0"
                  style="width: 320px; margin: 0 auto;"
                  class="text-center my-4 d-flex align-center">
                  <div
                    class="error--text">
                    <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>

                <div class="mt-7">
                  <v-btn
                    color="#240087"
                    height="40"
                    width="320"
                    elevation="0"
                    :disabled="form.mobile_key === ''"
                    @click="save()"
                    style="border-radius: 6px;"
                    class="white--text text-capitalize">
                    Lanjutkan
                  </v-btn>
                </div>

                <div class="fs-14 black_three mt-5">
                  Nomor salah atau tidak menerima kode? <span class="blue_one cursor-pointer font_weight_600">Ubah Nomor</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        form: {
          mobilephone: '',
          mobile_key: '',
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.form.mobile_key = this.$route.query.key
      this.form.mobilephone = `0${this.$route.params.id}`
    },
    methods: {
      HandleInput(inputkey) {
        this.form.mobile_key = inputkey;
      },

      async save () {
        this.message.error = ''

        const isValid = this.form.mobile_key !== '' ? true : false
        this.message.error = !isValid ? 'Kode verifikasi tidak boleh kosong' : ''
        if (isValid) {
          this.process.form = true

          await post('pos/auth/mobile_verification', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              // console.log(res.results.data.mobile_key)

              // window.location = `${process.env.BASE_URL}dashboard`
                this.$router.push({ path: `/register/jenis-usaha/${res.results.data.company_id}` })
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }

    }
  }
</script>

<style>
  /* #partitioned {
    padding-left: 15px;
    letter-spacing: 42px;
    border: 0;
    background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
    background-position: bottom;
    background-size: 50px 1px;
    background-repeat: repeat-x;
    background-position-x: 35px;
    width: 220px;
    outline : none;
  } */
  #partitioned {
    padding-left: 8px;
    letter-spacing: 27px;
    border: 0;
    background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
    background-position: bottom;
    background-size: 50px 1px;
    background-repeat: repeat-x;
    background-position-x: 35px;
    width: 300px;
    min-width: 300px;
      outline : none;
    font-size: 40px;
  }

#divInner{
  left: 0;
  position: sticky;
}

#divOuter{
  width: 290px; 
  overflow: hidden;
}

</style>